import { type ApiResult, type BaseParams, type LiquidIdResponse, type PostParams, type ResourceId } from '@pkg/types';

import { deleteRequest, getRequest, postRequest } from '@app/client/common/api';
import { links } from '@app/client/links/links.ts';

import { apiReturnResults } from '../../../ApiFactory';

type GetUserLidParams = BaseParams & { userId: ResourceId };
type UpdateUserLidParams = PostParams & { value: { item: string } };
export async function getUserLiquidId(params: GetUserLidParams): Promise<ApiResult<LiquidIdResponse>> {
    return getRequest<LiquidIdResponse>({
        ...params,
        target: links.nbe.liquidId.byUserId(params.userId),
        apiSettingsType: 'yatNode',
    });
}

export const callGetUserLiquidId = (params: GetUserLidParams) =>
    apiReturnResults<LiquidIdResponse>(getUserLiquidId, params);

export async function addItemToLiquidId(params: UpdateUserLidParams): Promise<ApiResult<LiquidIdResponse>> {
    return postRequest<LiquidIdResponse>({
        ...params,
        target: links.nbe.liquidId.items,
        apiSettingsType: 'yatNode',
    });
}

export const callAddItemToLiquidId = (params: UpdateUserLidParams) =>
    apiReturnResults<LiquidIdResponse>(addItemToLiquidId, params);

export async function removeItemToLiquidId(params: UpdateUserLidParams): Promise<ApiResult<LiquidIdResponse>> {
    return deleteRequest<LiquidIdResponse>({
        ...params,
        target: links.nbe.liquidId.items,
        apiSettingsType: 'yatNode',
    });
}

export const callRemoveItemToLiquidId = (params: UpdateUserLidParams) =>
    apiReturnResults<LiquidIdResponse>(removeItemToLiquidId, params);
